import { format, parse } from 'date-fns';
import isEmpty from 'lodash.isempty';

export const formatBirthDate = (date) => {
	if (isEmpty(date)) {
		return '';
	}
	return format(
		parse(date.substring(0, 10), 'yyyy-MM-dd', new Date()),
		'MM/dd/yyyy',
	);
};

export const formatPhoneNumber = (phoneNumber) => {
	if (isEmpty(phoneNumber)) {
		return '';
	}
	const cleaned = ('' + phoneNumber).replace(/\D/g, '');
	const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
	if (match) {
		return '(' + match[1] + ') ' + match[2] + '-' + match[3];
	}
	return phoneNumber;
};
